module.exports = __webpack_public_path__ + "media/images/official/special_migration_01-74cd6cda37937bdbc5f76b8864f67f6c.jpg";